import GPSCoordinates from "../GPSCoordinates";
import {EOperationType} from "../utils/EOperationType";
import {Icon} from "../Icon";

export abstract class AOperation {

    private _id: string;
    private _idUser : string;
    private _type: EOperationType;
    private _date: Date;
    private _geolocation: GPSCoordinates | undefined;
    private _isSynchro: boolean;
    private _commentary: string | undefined;
    private _icon: Icon;

    protected constructor(id: string, idUser: string, type: EOperationType, date: Date, icon: Icon, geolocation?: GPSCoordinates, isSynchro?: boolean, commentary?: string) {
        this._id = id;
        this._idUser = idUser;
        this._date = date;
        this._geolocation = geolocation;
        this._isSynchro = isSynchro !== undefined ? isSynchro : false;
        this._commentary = commentary;
        this._type = type;
        this._icon = icon;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get idUser(): string {
        return this._idUser;
    }

    set idUser(value: string) {
        this._idUser = value;
    }

    get date(): Date {
        return this._date;
    }

    set date(value: Date) {
        this._date = value;
    }

    get geolocation(): GPSCoordinates | undefined {
        return this._geolocation;
    }

    set geolocation(value: GPSCoordinates | undefined) {
        this._geolocation = value;
    }

    get isSynchro(): boolean {
        return this._isSynchro;
    }

    set isSynchro(value: boolean) {
        this._isSynchro = value;
    }

    get commentary(): string | undefined {
        return this._commentary;
    }

    set commentary(value: string | undefined) {
        this._commentary = value;
    }

    get type(): EOperationType {
        return this._type;
    }

    set type(value: EOperationType) {
        this._type = value;
    }

    get icon(): Icon {
        return this._icon;
    }

    set icon(value: Icon) {
        this._icon = value;
    }

    public isCorrect(): boolean {
        return (
            this.id !== "" &&
            this.idUser !== "" &&
            this.geolocation !== undefined &&
            this.geolocation.isValid() &&
            this.type in EOperationType
        );
    }
}
